import API from "api/axiosInstance";
import {
  setAccessToken,
  setCurrentPin,
  setDataUser,
  setIsLoading,
  setStatus,
  setWebsiteUser,
} from "./index";

export const fetchLogin = (email, password) => async (dispatch) => {
  dispatch(setIsLoading(true));

  try {
    const response = await API.post("/auth/website-login", {
      email,
      password,
    });
    dispatch(setIsLoading(false));
    dispatch(setStatus("success"));
    dispatch(setAccessToken(response.data.accessToken));
    dispatch(setWebsiteUser(response.data.user));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchWebsiteProfile = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/auth/website-profile");
    dispatch(setIsLoading(false));
    dispatch(setWebsiteUser(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchProfile = (id_karyawan) => async (dispatch) => {
  dispatch(setIsLoading(true));

  try {
    const response = await API.get(`/auth/profile-karyawan/${id_karyawan}`);
    dispatch(setIsLoading(false));
    dispatch(setStatus("success"));
    dispatch(setDataUser(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchLogout = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  setTimeout(() => {
    dispatch(setDataUser({}));
    dispatch(setWebsiteUser(null));
    dispatch(setAccessToken(null));
    dispatch(setIsLoading(false));
  }, 3000);
};

export const fetchCurrentPIN = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/auth/pin-website");
    dispatch(setIsLoading(false));
    dispatch(setCurrentPin(response.data.pin_website));
    return response.data.status;
  } catch (error) {
    dispatch(setIsLoading(false));
  }
};